import React from 'react';
import TableRowMui, { TableRowProps } from '@material-ui/core/TableRow';

export const TableRow: React.FC<TableRowProps> = ({ children, ...rest }) => {
	return <TableRowMui {...rest}>{children}</TableRowMui>;
};
